import queryString from 'query-string';
import { useLanguageLink } from './useLanguageLink';

export const useCarLink = () => {
  const f = ( { mfrSlug,mdlSlug,trimSlug, newOfferUUID, search } )=>{

    const l = useLanguageLink();
    const parts = [];
    if(mfrSlug){
      parts.push(`/make/${mfrSlug}`);
    }
    if(mdlSlug){
      parts.push(`/model/${mdlSlug}`);
    }
    if(trimSlug){
      parts.push(`/trim-level/${trimSlug}`);
    }
    if (newOfferUUID){
      parts.push(`/new/${newOfferUUID}`);
    }
    const qs = queryString.stringify({ search });
    return qs?.length ? l(parts.join('')) + '?' + qs :l(parts.join(''));
  };
  
  return f;
};